import React from "react";
import PolymatchResults from "./PolymatchResults";

const PolymatchResult_Linguistic = () => {
  // Pass English competition data to the results page
  return <PolymatchResults 
    competition="" 
    competitionHeading="English Linguistic"
    year="2025"
  />;
};

export default PolymatchResult_Linguistic;
